export default __webpack_public_path__ + "static/media/004-B-multimedia.1a43becc.svg";